import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import Typo from "../../common/Typo";
import IconTextCard from '../../common/IconTextCard';
import Footer from "../../common/Footer";
import { useDispatch } from "react-redux";
import { setQulificationStore } from "../../../redux/reducers/getData";
import { dataOfAllBusinessType } from "../../../data/plan-data";
import useMediaQuery from '@mui/material/useMediaQuery';
import API_CONFIG from '../../../config/config'

const { isSmallBusinessSign } = API_CONFIG;

const useStyles = makeStyles((theme) => ({
  animation: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxHeight: '78vh',
    overflowY: 'scroll',
    animation: `$lauchTime 600ms ${theme.transitions.easing.easeInOut}`
  },
  "@keyframes lauchTime": {
    "0%": {
      transform: "translateX(200%)",
    },
    "100%": {
      transform: "translateX(0)",
    }
  },
  subText: {
    fontSize: '1.5rem',
    marginTop: '3rem',
    lineHeight: '1.5rem',
  },
  infocard: {
    maxWidth: '1240px',
    padding: '1rem',
    justifyContent: "center",
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    marginTop: '.5rem',
  },
  inputDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  count: {
    display: 'flex',
    columnGap: '10px',
    alignItems: 'center',
    height: '60px',
    width: '450px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px 22px',
    margin: '2rem',
    animation: `$lauchTime 200ms ${theme.transitions.easing.easeInOut}`,
    '& input': {
      border: 'none',
      width: '60%',
      maxWidth: '60%',
      fontFamily: "Poppins",
      color: "#000648",
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: '1rem', 
    },
    '& input:focus': {
      border: 'none',
      outline: 'none'
    },
  },
  "@media (max-width: 960px)": {
    infocard: {
      gap: "1rem",
      justifyContent: "center",
      overFlowX: 'scroll'
    },
    icon: {
      display: 'none'
    },
    subText: {
      fontSize: '1rem',
      padding: '0 1rem',
      textAlign: 'center',
      marginTop: '1.5rem',
    },
    count: {
      height: '3rem',
      maxWidth: '290px',
      padding: '1rem',
      margin: '.5rem 0',
      '& input': {
        width: '100%',
        maxWidth: '100%',
      },
    }
  },
}));

function StepTwo({ setStepThree, setStepOne, setStepTwo, onButtonClick }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const isDesktop = useMediaQuery('(min-width:961px)'); 

  const [isEnable, setisEnable] = useState(false)
  const [dataArray, setDataArray] = useState(dataOfAllBusinessType)
  const [showText, setshowText] = useState(false)
  const [otherBusinessName, setOtherBusinessName] = useState('')

  useEffect(() => {
    // Check whether any business selected
    let anySelected = false;
    dataArray.forEach(item => {
      if (item.businessSelected === true) {
        anySelected = true;
      }
    });
    anySelected ? setisEnable(true) : setisEnable(false)
  }, [])

  const handleBackPage = () => {
    setStepTwo(false)
    setStepOne(true)
  }

  const handleNextPage = () => {
    let selectedBusinessList = []
    for (let data of dataArray) {
      if (data?.businessSelected) {
        selectedBusinessList?.push(data?.passValue)
      }
    }

    function containsNoValues(arr, values) {
      let allValuesPresent = true;
      for (let i = 0; i < values.length; i++) {
        if (arr.includes(values[i])) {
          allValuesPresent = false;
          break;
        }
      }
      return allValuesPresent;
    }

    const valuesToSupportedBusinessList = ["quick_service", "casual", "food_truck", "catering_events", "bars"];
    if (isSmallBusinessSign) {
      valuesToSupportedBusinessList.push("other")
    }
    const isWishlistBusinessType = containsNoValues(selectedBusinessList, valuesToSupportedBusinessList);

    //  logic for land on wishlist or step 03
    if (isWishlistBusinessType) {
      navigate('/steps/wishlist');
    } else {
      setStepTwo(false);
      setStepThree(true);
      onButtonClick("pagethree");
    }

    dispatch(setQulificationStore({ outerBussinessType: selectedBusinessList, otherBusinessName: otherBusinessName }))
  };

  const selectBusinessType = (index) => {
    const newArr = dataArray.map((item, i) => {
      // If the item is the clicked one, toggle its selection
      if (i === index) {
        return { ...item, businessSelected: !item.businessSelected };
      }
      // If it's not the clicked item, unselect it
      return { ...item, businessSelected: false };
    });
    setDataArray(newArr);
  
    // Enable "Next" only if any item is selected and is not "Other"
    const isAnySelected = newArr.some(item => item.businessSelected && item.text !== "Other");
    setisEnable(isAnySelected);
  
    // Set showText to true only if the selected item's text is "Other" and it is selected
    const selectedItem = newArr[index];
    setshowText(selectedItem.businessSelected && selectedItem.text === "Other");
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setOtherBusinessName(value);

    if (value.trim() !== '') {
      setisEnable(true);
    } else {
      setisEnable(false);
    }
  };

  return (
    <>
      <div className={classes.animation}>
        <Typo className={classes.subText} variant='pp01B'> {isDesktop 
            ? "Select the business type that best fit your business:" 
            : "Select any of the business types below that best fit your business:"}</Typo>
        {dataArray &&
          <div className={classes.infocard}>
            {
              dataArray?.map((item, index) => {
                return (
                  <IconTextCard
                    key={index}
                    icon={item?.icon}
                    onClick={() => selectBusinessType(index)}
                    text={item?.text}
                    selectedDiv={item?.businessSelected}
                  />
                )
              })
            }
          </div>
        }

        <form className={classes.inputDiv}>
          {showText && <div className={classes.count}>
            <input
              id="businesstypecustom"
              name="businesstypecustom"
              value={otherBusinessName}
              onChange={handleChange}
              onBlur={handleChange}  // Use onBlur event to check for changes
              autoComplete="off"
              placeholder="Add your business type"
            />
          </div>}
        </form>

      </div>
      <Footer
        buttonText="Next"
        onSubmit={handleNextPage}
        handleBackPage={handleBackPage}
        // This below is on purpose b/c Footer has isDisable prop upside down
        isDisable={isEnable}
      />
    </>
  );
}

export default StepTwo;

